import React from 'react';
import { Star } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './review-stars.style';

const STAR_COUNT = 5;

export const ReviewStars: React.FC = () => (
  <Styled.ReviewStars>
    {Array.from({ length: STAR_COUNT }, (_, index) => (
      <Icon key={index} icon={Star} />
    ))}
  </Styled.ReviewStars>
);
